export default __webpack_public_path__ + "static/media/v.82e4ae82.png";